<div class="card">
    <div class="card-header">
        <i class="fas fa-location-crosshairs mr-2"></i>
        <ng-container *ngIf="viewMode == ViewMode.INSERT">Aktion anlegen</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.EDIT">Aktion bearbeiten</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.VIEW">Aktion</ng-container>
    </div>
    <div class="card-body">
        <form [formGroup]="form">
            <div class="form-group">
                <label>Ereignis</label>
                <select class="form-control" formControlName="type" *ngIf="viewMode != ViewMode.VIEW">
                    <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                    <option value="new_document">{{ 'new_document' | eventType }}</option>
                </select>
                <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.type | eventType }}</p>
            </div>

            <ng-container *ngIf="form.value.type">
                <div class="form-group">
                    <label>Aktion</label>
                    <select class="form-control" formControlName="action" *ngIf="viewMode != ViewMode.VIEW">
                        <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                        <option value="send_mail_from_attribute">{{ 'send_mail_from_attribute' | actionType }}</option>
                    </select>
                    <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.action | actionType }}</p>
                </div>
            </ng-container>

            <ng-container *ngIf="form.value.action == 'send_mail_from_attribute'">
                <div class="form-group" formGroupName="data">
                    <label>Dokumenttyp</label>
                    <select class="form-control" formControlName="FTID" *ngIf="viewMode != ViewMode.VIEW">
                        <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                        <option *ngFor="let fileType of fileTypes" [ngValue]="fileType.FTID">
                            {{ fileType.name }}
                        </option>
                    </select>
                    <p *ngIf="viewMode == ViewMode.VIEW">{{ event?.filetype }}</p>
                </div>

                <div class="form-group" formGroupName="data" *ngIf="attributes">
                    <label>Attribut</label>
                    <ng-container *ngIf="viewMode != ViewMode.VIEW">
                        <select class="form-control" formControlName="ATTID">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option *ngFor="let attribute of attributes" [ngValue]="attribute.ATTID">
                                {{ attribute.name }}
                            </option>
                        </select>
                        <div class="form-text text-warning" *ngIf="form.value.action == 'send_mail_from_attribute'">
                            Das gewählte Attribut muss eine E-Mail Adresse enthalten.
                        </div>
                    </ng-container>
                    <p *ngIf="viewMode == ViewMode.VIEW">{{ event?.attribute }}</p>
                </div>
            </ng-container>
        </form>

        <ng-container *ngIf="viewMode == ViewMode.VIEW">
            <button type="button" class="btn btn-primary mr-2" (click)="setMode(ViewMode.EDIT)" [attr.data-right]="'MASTER_DATA_EDIT' | right" *ngIf="userService.hasRight('MASTER_DATA_EDIT')">Bearbeiten</button>
            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
            <button type="button" class="btn btn-danger float-right"
                    [attr.data-right]="'MASTER_DATA_EDIT' | right"
                    *ngIf="userService.hasRight('MASTER_DATA_EDIT')"
                    (click)="delete()"
            >Löschen</button>
        </ng-container>

        <ng-container *ngIf="viewMode == ViewMode.EDIT">
            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
            <button type="button" class="btn btn-secondary ml-2" (click)="cancelEdit()">Abbrechen</button>
        </ng-container>

        <ng-container *ngIf="viewMode == ViewMode.INSERT">
            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
            <button type="button" class="btn btn-secondary ml-2" (click)="cancel()">Abbrechen</button>
        </ng-container>

    </div>
</div>
